<!-- 重要的事情说三遍！！！ -->
<!-- 不要随意修改模板的内容，需要修改务必复制一份到views文件夹再编辑！！！ -->
<!-- 不要随意修改模板的内容，需要修改务必复制一份到views文件夹再编辑！！！ -->
<!-- 不要随意修改模板的内容，需要修改务必复制一份到views文件夹再编辑！！！ -->

<template>
    <div class="container box-like">
        <div class="button-box">
            <a-button icon="plus" type="primary">新建客户资料</a-button>
            <a-button icon="retweet">重置所有筛选条件</a-button>
        </div>
        <!-- scroll: 页面太小的时候会让表格至少有相应的长度，如果表格项很少就去掉这个，表格项太多的话适当增加 -->
        <a-table :data-source="tableData" :columns="columns" :rowKey="(rec) => rec.id" :scroll="{ x: 1500 }">
            <!-- slot对应配置文件中customRender的内容 -->
            <div slot="c-type" slot-scope="text">
                <a-switch :checked="Boolean(2 - text)" disabled />
            </div>
            <div slot="c-action" style="display: flex;">
                <a-button type="primary" style="margin-right: 4px;" @click="onEdit">编辑</a-button>
                <a-button type="danger">删除</a-button>
            </div>
            <div slot="filterDropdown" slot-scope="{ confirm, column }" style="padding: 8px">
                <a-input class="filter-input" :placeholder="`搜索${column.title}`" v-model="filterItems[column.filterIndex]"
                    v-if="column.type === 'input'" />
                <a-select class="filter-select" :placeholder="`请选择${column.title}`" :mode="column.multi ? 'multiple' : ''"
                    v-model="filterItems[column.filterIndex]" v-if="column.type === 'select'">
                    <a-select-option :value="item.id" v-for="(item, index) in column.items" :key="index">{{item.name}}</a-select-option>
                </a-select>
                <div>
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="onFilterSearch(confirm)">搜索</a-button>
                    <a-button size="small" icon="retweet" style="width: 90px" @click="onFilterReset(column.filterIndex, confirm)">重置</a-button>
                </div>
            </div>
            <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>

        <a-modal title="编辑信息" :visible="showModal" okText="提交" cancelText="返回" @ok="submit" :maskClosable="false"
            centered @cancel="showModal = false">
            <a-form-model layout="horizontal" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" :model="formModel">
                <a-form-model-item label="用户名">
                    <a-input v-model="formModel.username" placeholder="请输入用户名" />
                </a-form-model-item>
                <a-form-model-item label="密码">
                    <a-input v-model="formModel.password" placeholder="请输入密码" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import {
    stationMap
} from '@/common/project-config'
import {
    formModel,
    columns
} from './table-simple.conf.js'

export default {
    name: 'table_simple',
    computed: {
        ...mapState('stored', ['userInfo'])
    },
    data() {
        return {
            // 表格数据
            tableData: [],
            // 显示编辑内容
            showModal: false,
            // 筛选内容
            filterItems: {},
            // 编辑内容配置，在配置文件里
            formModel: { ...formModel},
            // 表格配置，在配置文件里
            columns: [...columns]
        }
    },
    created() {

    },
    mounted() {
        this.onInit()
    },
    props: {

    },
    watch: {

    },
    methods: {
        ...mapMutations('global', ['setLoading']),
        async onInit() {
            this.setLoading('页面加载中...')
            await this.initMap()
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.guest_source.get, {
                status: this.userInfo.stationId,
                ...this.filterItems
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data.map((s) => {
                let _s = { ...s}
                _s.status = stationMap[_s.status]
                return _s
            })
            this.setLoading('')
        },
        async initMap() {
            // 一般情况下，这里写的是选择型的筛选条件的选项，从后端获取
            let res, index
            res = await this.$util.request(this.$ctrl.guest_type.get, {
                status: this.userInfo.stationId,
            })
            index = this.columns.findIndex((s) => s.dataIndex === 'typename')
            this.columns[index].items = res.data.data
        },
        onFilterSearch(confirm) {
            this.onInit()
            confirm()
        },
        onFilterReset(key, confirm) {
            if (this.filterItems.hasOwnProperty(key)) {
                this.filterItems[key] = ''
                this.onInit()
                confirm()
            }
        },
        onEdit() {

        },
        submit() {

        }
    }
}
</script>

<style scoped lang="less">
    @import './table-simple.less';
</style>
